import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { ActionHistoryDetail } from '../../../common/action-history-grid/types/ActionHistoryDetail';

export const useGetWOActionHistory = (workOrderID: number, enabled: boolean) => {

    const { data, isLoading } = useQuery({
        queryKey: ['wo-action-history', workOrderID],
        queryFn: async () => await apiClient.get('work-order/action-history',
            { params: { workOrderID: workOrderID } }) as ActionHistoryDetail[],
        enabled: enabled
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
